export default "__VITE_ASSET__D0n5Cymt__"